import React, {useEffect, useState} from 'react';

const baseUrl = "https://cad-assets-storage-api.cloudservices.dev.mylectra.com/api"

export default function useFetchApplications() {

    const initialState = {
        isLoaded: false,
        applications: [],
    }
    const [state, setApplications] = useState(initialState)

    const updateState = apps => setApplications({
        isLoaded: true,
        applications: apps
    })

    //TODO: useFetch?
    useEffect(() => {
        fetch(baseUrl + '/applications')
            .then(res => res.json())
            .then(jsonApplications => getApplicationsWithMetadata(toApplications(jsonApplications))
                .then(apps => updateState(apps)))
        },
        [])

    return state
}

async function getApplicationsWithMetadata(applications) {

    for (let application of applications) {
        let assets = application.assets

        for (let asset of assets) {
            if (asset.applicationId !== "") {
                let uri = baseUrl + "/applications/" + asset.applicationId + '/groups/' + asset.groupId + '/assets/metadata/'

                console.log(">>> fetch: " + uri)
                await fetch(uri)
                    .then(res => res.json())
                    .then(jsonMetadata => asset.metadata = toMetadata(jsonMetadata))
            } else {
                console.log("skipped: ")
                console.log(asset)
            }
        }
    }
    return applications
}

function toApplications(jsonApplications) {
    let result = [];

    jsonApplications.forEach(application => {

        result.push({
            id: application.id,
            assets: []
        });
        let index = result.findIndex(i => i.id === application.id);
        application.assets.forEach(asset => {
            result[index].assets.push({
                applicationId: asset.applicationId,
                groupId: asset.groupId,
                name: asset.name,
                uri: asset.uri,
                metadata: {},
            });
        })
    });

    return result;
}

function toMetadata(json) {
    return {
        applicationId: json["applicationId"],
        groupId: json["groupId"],
        tags: json["tags"],
        author: json["author"],
        creationDate: json["creationDate"]
    }
}